(() => {
  if (!customElements.get('gg-cart-express')) customElements.define('gg-cart-express', class extends HTMLElement {
    connectedCallback() {
      this.media = window.matchMedia('(min-width:900px)');
      this.sync = () => { this.querySelector('details').open = this.media.matches; };
      this.sync();
      this.media.addEventListener('change', this.sync);
    }
    disconnectedCallback() { this.media?.removeEventListener('change', this.sync); }
  });

  document.addEventListener('click', event => {
    const summary = event.composedPath().find(node => node.matches?.('.gg-cart-express-disclosure > summary'));
    if (!summary) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    summary.parentElement.open = !summary.parentElement.open;
  }, true);
  const syncViewport = () => document.documentElement.style.setProperty('--gg-cart-vh', `${Math.round(Math.min(window.innerHeight, window.visualViewport?.height || window.innerHeight))}px`);
  syncViewport();
  window.addEventListener('resize', syncViewport, {passive:true});
  window.visualViewport?.addEventListener('resize', syncViewport, {passive:true});
  let bestsellerRequest;
  class GGCartBestsellers extends HTMLElement {
    connectedCallback() {
      const observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        observer.disconnect();
        bestsellerRequest ||= fetch(this.dataset.url, {headers:{Accept:'text/html'}}).then(response => {
          if (!response.ok) throw Error('Bestsellers unavailable');
          return response.text();
        }).catch(error => {bestsellerRequest = undefined;throw error;});
        bestsellerRequest.then(html => {
          if (!this.isConnected) return;
          const content = new DOMParser().parseFromString(html, 'text/html').querySelector('.gg-cart-bestsellers-content');
          if (content) this.replaceChildren(...content.childNodes);
          else this.replaceChildren();
        }).catch(() => this.replaceChildren());
      });
      observer.observe(this);
      this.observer = observer;
    }
    disconnectedCallback() {this.observer?.disconnect();}
  }
  if (!customElements.get('gg-cart-bestsellers')) customElements.define('gg-cart-bestsellers', GGCartBestsellers);
  let busy = false;
  const root = window.Shopify?.routes?.root || '/';
  async function add(body, source, button) {
    if (busy) return;
    busy = true;
    const wasDisabled = button?.disabled;
    if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
    let added = false;
    let error = source.querySelector('[data-gg-cart-error]');
    if (!error) {
      error = document.createElement('p');
      error.dataset.ggCartError = '';
      error.setAttribute('role', 'alert');
      error.className = 'message message-danger text-danger';
      source.append(error);
    }
    error.textContent = '';
    try {
      const drawer = document.querySelector('cart-modal');
      const sectionId = drawer?.closest('.shopify-section')?.id.replace('shopify-section-', '');
      body.set('sections', [sectionId, 'cart-bubble'].filter(Boolean).join(','));
      body.set('sections_url', window.location.pathname);
      const response = await fetch(root + 'cart/add.js', {method:'POST', headers:{Accept:'application/json'}, body});
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || window.cartStrings?.error);
      added = true;
      const bubbleHTML = result.sections?.['cart-bubble'];
      const bubble = document.getElementById('CartBubble');
      if (bubble && bubbleHTML) {
        const doc = new DOMParser().parseFromString(bubbleHTML, 'text/html');
        const count = doc.body.textContent.trim();
        bubble.textContent = count;
        bubble.classList.toggle('hidden', !Number(count));
      }
      if (!drawer) { window.location.assign(root + 'cart'); return; }
      if (result.sections?.[sectionId]) drawer.updateFromSectionHtml(result.sections[sectionId]);
      else await drawer.reloadContent();
      await drawer.show({trigger:button});
    } catch (err) {
      if (added) window.location.assign(root + 'cart');
      else error.textContent = err.message || window.cartStrings?.error;
    } finally {
      busy = false;
      if (button) {button.disabled = wasDisabled;button.removeAttribute('aria-busy');}
    }
  }
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('.gg-native-product-form')) return;
    if (!document.querySelector('cart-modal')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (form.reportValidity()) add(new FormData(form), form, event.submitter || form.querySelector('[type=submit]'));
  }, true);
  document.addEventListener('click', event => {
    const quick = event.target.closest('quick-add-button[variant-id]');
    const id = quick?.getAttribute('variant-id');
    if (!id || !document.querySelector('cart-modal')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const body = new FormData();
    body.set('id', id);
    body.set('quantity', '1');
    add(body, quick, quick.querySelector('button'));
  }, true);
})();
